import { PencilIcon, SwatchIcon, TrashIcon } from '@heroicons/react/24/outline';

import { Icon } from '@/components/core/Icon';
import { useTranslation } from '@/hooks/useTranslation';
import { BrowseActiveFilter, FILTER_TYPE } from '@/pages/browse/types';

import { FilterMenuItem } from './FilterMenuItem';

interface FilterListActionsProps {
    activeFilters: Record<string, BrowseActiveFilter>;
    onCreateFilter?: () => void;
    onEditFilter?: () => void;
    onDeleteFilter?: () => void;
}

function canMutateSelectedCustomFilter(
    activeFilters: Record<string, BrowseActiveFilter>,
): boolean {
    const selected = activeFilters[FILTER_TYPE.USER_DEFINED];
    return Boolean(selected?.name && !selected.readOnly);
}

export function FilterListActions({
    activeFilters,
    onCreateFilter,
    onEditFilter,
    onDeleteFilter,
}: FilterListActionsProps) {
    const { t } = useTranslation();
    const canMutate = canMutateSelectedCustomFilter(activeFilters);

    return (
        <>
            <li className="tw-list-none">
                <FilterMenuItem onSelect={onCreateFilter}>
                    <span className="tw-inline-flex tw-items-center tw-gap-1.5 tw-text-t-sm tw-text-t-primary">
                        <Icon icon={SwatchIcon} size="sm" className='tw-icon-primary' />
                        {t('ITEMS_SEARCH_FILTER.CUSTOM_FILTER')}
                    </span>
                </FilterMenuItem>
            </li>
            {canMutate && (
                <>
                    <li className="tw-list-none">
                        <FilterMenuItem onSelect={onEditFilter}>
                            <span className="tw-inline-flex tw-items-center tw-gap-1.5 tw-text-t-sm tw-text-t-primary">
                                <Icon icon={PencilIcon} size="sm" className="tw-icon-primary" />
                                {t('ITEMS_SEARCH_FILTER.EDIT_SELECTED_CUSTOM_FILTER')}
                            </span>
                        </FilterMenuItem>
                    </li>
                    <li className="tw-list-none">
                        <FilterMenuItem onSelect={onDeleteFilter}>
                            <span className="tw-inline-flex tw-items-center tw-gap-1.5">
                                <Icon icon={TrashIcon} size="sm" className="tw-icon-primary" />
                                {t('ITEMS_SEARCH_FILTER.DELETE_SELECTED_CUSTOM_FILTER')}
                            </span>
                        </FilterMenuItem>
                    </li>
                </>
            )}
            <li
                role="separator"
                className="tw-w-full tw-h-px tw-my-1 tw-list-none tw-bg-gray-200"
            />
        </>
    );
}
